import { useAtom } from "jotai";
import { projectDetailsAtom } from "../utils/atoms/projectDetailsAtom";

export const useASelectedCountry = () => {
  const [projectDetails] = useAtom(projectDetailsAtom);

  const selectedCountry =
    projectDetails?.locationDTO?.country ||
    projectDetails?.projectDTO?.country ||
    projectDetails?.locationDTO?.address?.country ||
    "";

  return selectedCountry;
};

export default useASelectedCountry;
